import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; 

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('CLUB-VIP-JWT');
  if(!token){
    return <Navigate to="/login" />;
  }
  const decodedToken = jwtDecode(token);

  if(decodedToken?.role == "admin"){
    return <Navigate to="/login" />;
  }

  return children;
};

export const ProtectedRouteAdmin = ({ children }) => {
    const token = localStorage.getItem('CLUB-VIP-JWT');
    
    if(!token){
      return <Navigate to="/login" />;
    }
  
    const decodedToken = jwtDecode(token);
    
    if(decodedToken?.role != "admin"){
        return <Navigate to="/login" />;
    }
    
  
    return children;
};
  

export default ProtectedRoute;
